import React from "react";
import { Outlet } from "react-router-dom";
import EmployeeNav from "../EmployeeNav/Nav";
import EmployeeFooter from "../../Main/Footer/Footer";


export default function CandidateMain() {
  return (
    <>
      <EmployeeNav />
      <Outlet />
      <EmployeeFooter />
    </>
  );
}
